/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacts_Download_Selected_PdfInputs */



/**
* | output |
* | --- |
* | "PDF (ZIP)" |
*
* @param {Artifacts_Download_Selected_PdfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_download_selected_pdf = /** @type {((inputs?: Artifacts_Download_Selected_PdfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Download_Selected_PdfInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("PDF (ZIP)")
	return /** @type {LocalizedString} */ ("PDF (ZIP)")
});